import { Button } from "reactstrap";
import { useState } from "react";
import { Modal } from "rsuite";

import UppyFile, { UppyFileInterface } from "../Inputs/UppyFile";
import { FileInterface } from "../../types/RecordInterfaces";
import CustomToggle from "../Drawers/Fields/CustomToggle";

interface UppyModalProps {
  open: boolean;
  onClose: () => void;
  afterSubmit?: (files: UppyFileInterface | UppyFileInterface[]) => void;
  fileFieldPrivacySetting?: boolean; // For adding a file to Growth Drive, from a File Field.
  showFileExplorerButton?: boolean;
  /** An array of files to filter them from the file explorer.  */
  filesToFilter: FileInterface[];
}

function UppyModal({
  open,
  onClose,
  afterSubmit,
  fileFieldPrivacySetting,
  showFileExplorerButton = false,
  filesToFilter,
}: UppyModalProps) {
  const [isPrivate, setIsPrivate] = useState(true);

  const finalIsPrivate =
    typeof fileFieldPrivacySetting === "boolean"
      ? fileFieldPrivacySetting
      : true;

  return (
    <Modal open={open} onClose={onClose} size="xs" keyboard={true}>
      <div className="modal-header tw:flex tw:items-center">
        <h5 className="modal-title tw:mb-0" id="exampleModalLabel">
          Upload Files
        </h5>
        <Button onClick={onClose} size="sm">
          Done
        </Button>
      </div>
      <div className="modal-body tw:pb-2">
        {typeof fileFieldPrivacySetting === "boolean" ? null : (
          <CustomToggle
            value={isPrivate}
            handleChange={(e) => setIsPrivate(e.target.checked)}
            title="Private"
          />
        )}
        <div className="tw:flex-col tw:justify-items-center tw:pb-4">
          <UppyFile
            fileType={"SingleFile"}
            multiFiles={true}
            afterSubmit={afterSubmit ? afterSubmit : () => {}}
            meta={{ isPublic: !finalIsPrivate }}
            showFileExplorerButton={showFileExplorerButton}
            filesToFilter={showFileExplorerButton ? filesToFilter : []}
          />
        </div>
      </div>
    </Modal>
  );
}

export default UppyModal;
